<template>
  <div>
    <el-form label-width="110px" :model="entrust" size="small" :rules="rules" ref="entrustForm" >
      <el-card shadow="never" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
          <span>产品检验信息</span>
          <el-button size="small" type="primary" plain style="margin-left: 20px;" @click="handleSelectTestPorject">选择检验项目</el-button>
        </div>
        <div>
          <el-table border :data="entrust.productItemList">
            <el-table-column
              label="序号"
              align="center"
              type="index"
              width="80">
            </el-table-column>
            <el-table-column prop="typeName" label="产品类别"  width="150">
            </el-table-column>
            <el-table-column
              prop="itemName"
              label="产品/方法"
              width="150">
              <template slot-scope="scope">
                {{scope.row.itemName}}
                <el-tooltip class="item" effect="dark" :content="scope.row.selRefine.fullName" :disabled="!scope.row.selRefine.fullName" placement="top-start" v-if="scope.row.selRefine.fullName">
                 <span style="color: red;">[{{scope.row.selRefine.fullName}}]</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="testProjects"
              label="检验项目">
              <template slot-scope="scope">
                <standard-item-display v-model="entrust.productItemList[scope.$index]" @change="handleDelItem(scope.$index)"></standard-item-display>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              align="center"
              width="150">
              <template slot-scope="scope">
                <el-button type="text" @click="handleDelStandard(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
      <el-card shadow="never" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
          <span>检验周期及报告</span>
        </div>
        <div>
       <!--   <el-alert
            title="检验周期的费用和周期以选择的机构的为准！"
            type="warning"
            style="margin-bottom: 5px;"
            show-icon>
          </el-alert>-->
          <el-form-item label="检验周期：" prop="cycleCode">
            <el-radio-group v-model="entrust.cycleCode">
              <el-radio :style="item.vipDescript?radioHeight2:''" v-for="item in selectOptions.cycleOptions" :label="item.code" :key="item.code" @change="resetPrice" border>
                <span style="color:red;" v-if="item.vipDescript">{{item.vipDescript}}<br/></span>
                <span :style="item.vipDescript?'padding-left: 22px':''"> {{item.name}}
                  (
                  <span v-if="item.description">{{item.description|filterDes}}</span>
                  <span v-if="item.descript">{{item.descript|filterDes}}</span>
                  )
                </span>
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="报告及发票：" prop="reportSendCode">
            <el-radio-group v-model="entrust.reportSendCode">
              <el-radio v-for="item in selectOptions.sendTypeOptions" :label="item.code" :key="item.code" @change="resetPrice" border>
                {{item.name}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="报告类型：" prop="reportTypeCodeArray">
            <el-checkbox-group v-model="entrust.reportTypeCodeArray">
              <el-checkbox-button v-for="item in selectOptions.reportTypeOptions" :label="item.code" :key="item.code" @change="resetPrice">
                {{item.name}}
              </el-checkbox-button>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="报告形式：" prop="reportFormCodeArray">
            <el-checkbox-group v-model="entrust.reportFormCodeArray">
              <el-checkbox-button v-for="item in selectOptions.reportFormOptions" :label="item.code" :key="item.code">
                {{item.name}}
              </el-checkbox-button>
            </el-checkbox-group>
          </el-form-item>
        </div>
      </el-card>
      <el-card shadow="never" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
          <span>选择检验机构</span>
        </div>
        <div>
          <el-form-item label="资质要求：" prop="qualificationsCodeArray">
            <div style="display: flex">
              <el-checkbox-group  v-model="entrust.qualificationsCodeArray">
                <el-checkbox-button v-for="item in commonUtils.getDictPara('org_qual')" :label="item.code" :key="item.code">
                  {{item.name}}
                </el-checkbox-button>
              </el-checkbox-group>
              <el-button type="primary" plain style="margin-left: 20px;" :loading="orgLoading" @click="handleSelectTestOrg()">搜索机构</el-button>
            </div>
            <div style="margin-top: 20px;">
              <el-table border
                        v-loading="orgLoading"
                        :data="testOrgData">
                <el-table-column
                  prop="name"
                  label="检验机构"
                  show-overflow-tooltip
                  width="280">
                </el-table-column>
                <el-table-column
                  prop="qualificationsName"
                  label="检验资质"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="address"
                  show-overflow-tooltip
                  label="地址">
                </el-table-column>
                <el-table-column
                  prop="phone"
                  show-overflow-tooltip
                  width="120"
                  label="联络电话">
                </el-table-column>
                <el-table-column
                  prop="disPrice"
                  width="250"
                  label="价格(元）">
                  <template slot="header" v-if="!vipInfo">
                    价格(元）
                    <span v-if="!vipInfo" class="beVip">
                      <img class="beVipImg" src="@/assets/img/vip/bevip.png" @click="toPopVip"/>
                      <!--<el-button style="font-weight: bold;color: red;" type="text" @click="toPopVip">成为会员</el-button>-->
                    </span>
                  </template>
                  <template slot-scope="scope">
                    <span v-if="vipInfo">
                      <span style="font-size: 21px;color: red;">{{scope.row.vipPrice}}</span>
                      <span style="margin-left: 3px;text-decoration:line-through; ">原价:{{scope.row.disPrice}}</span>
                    </span>
                    <span v-if="!vipInfo">
                      <span style="font-size: 21px;">{{scope.row.disPrice}}</span>
                      <span style="margin-left: 3px;color: red;">会员:{{scope.row.vipPrice}}</span>
                    </span>
                    <el-button type="text" size="small" @click="viewPiceDetail(scope.row)" style="margin-left: 5px;">明细</el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  label="选择"
                  align="center"
                  width="100">
                  <template slot-scope="scope">
                    <el-radio :label="scope.row.id" v-model="templateRadio"
                              @change.native="getTemplateRow(scope.$index,scope.row)">选择
                    </el-radio>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="orderRemark">
                <div style="color: red;margin-top: 20px;">{{selOrg.name}}下委托提醒：</div>
                <div style="margin-left: 90px;white-space: pre-line">{{orderRemark}}</div>
              </div>
            </div>
          </el-form-item>
        </div>
      </el-card>
    </el-form>
    <el-dialog
      title="选择检验项目"
      :visible.sync="dialogVisible"
      :destroy-on-close = "true"
      width="75%">
      <select-product v-if="dialogVisible" v-model="tmpProductItemList" :noCheckItemArray="seleIds" :selRefines="selRefines"></select-product>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSaveTestPorject">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-if="dialogPrice"
      :title="titlePrice"
      center
      :visible.sync="dialogPrice"
      :destroy-on-close = "true"
      width="65%">
      <price-detail :productItem="productItem" :entrust = "entrust"></price-detail>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogPrice = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-divider></el-divider>
    <div class="clearfix" style="text-align: center">
      <el-button size="medium" type="success" @click="handleSave" :loading="nextLoading">下一步</el-button>
    </div>
  </div>
</template>

<script>
import SelectProduct from './select-product'
import StandardItemDisplay from './standard-item-display'
import { getInspectionOrgList } from '@/api/test/testInspectionOrg'
import { saveTestEntrustFirstPage, getTestEntrustResponse } from '@/api/test/entrust'
import _ from 'lodash'
import PriceDetail from './price-detail'

export default {
  name: 'test-product',
  components: { PriceDetail, StandardItemDisplay, SelectProduct },
  props: {
    entrustId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      nextLoading: false,
      dialogPrice: false,
      checkAll: false,
      radioHeight2: { height: '45px' },
      entrust: {
        cycleCode: '',
        reportSendCode: '',
        productItemList: [],
        reportTypeCodeArray: [],
        reportFormCodeArray: [],
        qualificationsCodeArray: []
      },
      tmpProductItemList: [],
      seleIds: [],
      selRefines: [],
      dialogVisible: false,
      orgLoading: false,
      cycle: '',
      reportSend: '',
      reportCategory: [],
      reportType: [],
      qualification: [],
      templateRadio: '1',
      testOrgData: [],
      searchModel: '1', // 0搜索 ，1自动
      productItem: {},
      titlePrice: '费用明细',
      orderRemark: '',
      selOrg: {},
      selectOptions: {
        cycleOptions: [],
        sendTypeOptions: [],
        reportTypeOptions: [],
        reportFormOptions: []
      },
      // rules前端验证
      rules: {
        reportSendCode: [{ required: true, message: '请选择报告及发票', trigger: 'blur' }],
        cycleCode: [{ required: true, message: '请选择检验周期', trigger: 'blur' }],
        reportTypeCodeArray: [{ required: true, message: '请选择报告类型', trigger: 'blur' }],
        reportFormCodeArray: [{ required: true, message: '请选择报告形式', trigger: 'blur' }]
      }
    }
  },
  filters: {
    filterDes: function (desc) {
      if (desc.split('__').length > 1) {
        return desc.split('__')[0]
      } else {
        return desc
      }
    }
  },
  computed: {
    vipInfo () {
      return this.$store.state.user.vipInfo
    }
  },
  watch: {
    'vipInfo': function () {
    },
    'entrust.qualificationsCodeArray': function () {
      this.handleSelectTestOrg('auto')
    },
    'templateRadio': function (newValue, oldValue) {
      this.testOrgData.forEach((row, index) => {
        let node = row
        if (node.id === newValue) {
          this.selOrg = node
          this.orderRemark = node.orderRemark
        }
      })
    }
  },
  mounted () {
    // 初始化选项
    this.selectOptions.cycleOptions = this.commonUtils.getDictPara('sys_cycle')
    this.selectOptions.sendTypeOptions = this.commonUtils.getDictPara('send_type')
    this.selectOptions.reportTypeOptions = this.commonUtils.getDictPara('report_type')
    this.selectOptions.reportFormOptions = this.commonUtils.getDictPara('report_form')
    // 如果是新增 添加默认值
    if (this.entrustId) {
      this.entrust.entrustId = this.entrustId
      this.getTestEntrustResponse()
    } else {
      if (this.selectOptions.cycleOptions.length > 0) {
        this.entrust.cycleCode = this.selectOptions.cycleOptions[0].code
      }
      if (this.selectOptions.sendTypeOptions.length > 0) {
        this.entrust.reportSendCode = this.selectOptions.sendTypeOptions[0].code
      }
      if (this.selectOptions.reportTypeOptions.length > 0) {
        this.entrust.reportTypeCodeArray.push(this.selectOptions.reportTypeOptions[0].code)
      }
      if (this.selectOptions.reportFormOptions.length > 0) {
        this.entrust.reportFormCodeArray.push(this.selectOptions.reportFormOptions[0].code)
      }
    }
  },
  methods: {
    getTestEntrustResponse () {
      let param = { entrustId: this.entrustId }
      getTestEntrustResponse(param).then(res => {
        var result = res.data
        if (result.rtnCode === '0') {
          if (result.bizData.productItemDataList) {
            for (var i = 0; i < result.bizData.productItemDataList.length; i++) {
              if (result.bizData.productItemDataList[i].typeParentName !== null && result.bizData.productItemDataList[i].typeParentName !== '') {
                result.bizData.productItemDataList[i].typeName = result.bizData.productItemDataList[i].typeParentName + ' - ' + result.bizData.productItemDataList[i].typeName
              }
            }
            this.entrust.productItemList = result.bizData.productItemDataList
          }
          if (result.bizData.testEntrust) {
            if (result.bizData.testEntrust.cycleCode) {
              this.entrust.cycleCode = result.bizData.testEntrust.cycleCode
            }
            if (result.bizData.testEntrust.reportSendCode) {
              this.entrust.reportSendCode = result.bizData.testEntrust.reportSendCode
            }
            if (result.bizData.testEntrust.reportTypeCode) {
              this.entrust.reportTypeCodeArray = []
              result.bizData.testEntrust.reportTypeCode.split(',').forEach(v => {
                this.entrust.reportTypeCodeArray.push(v)
              })
            }
            if (result.bizData.testEntrust.reportFormCode) {
              result.bizData.testEntrust.reportFormCode.split(',').forEach(v => {
                this.entrust.reportFormCodeArray.push(v)
              })
            }
            if (result.bizData.testEntrust.qualificationsCode) {
              result.bizData.testEntrust.qualificationsCode.split(',').forEach(v => {
                this.entrust.qualificationsCodeArray.push(v)
              })
            }
            if (result.bizData.testEntrust.orgId) {
              this.templateRadio = result.bizData.testEntrust.orgId
            }
            this.handleSelectTestOrg()
          }
        } else {
          this.$message.error(result.bizMsg)
        }
      }).catch(() => {
        this.$message.error('加载失败')
      })
    },
    // 选择机构
    getTemplateRow (index, row) {
      this.templateSelection = row
      this.testOrgData.forEach((row, index) => {
        row.enableFlag = this.templateSelection.id
      })
      row.enableFlag = 1
      this.selectOptions.cycleOptions = row.cycleList
    },
    handleSelectTestPorject () {
      this.seleIds = []
      this.selRefines = []
      this.entrust.productItemList.forEach(product => {
        product.standardList.forEach(standard => {
          // 210113 add by start 吴家辉
          if (standard.selRefine && standard.selRefine.id) {
            this.selRefines.push(product.itemId + ',' + standard.itemId + ',' + standard.selRefine.id)
          }
          // 210113 add by end 吴家辉
          standard.standardList.forEach(item => {
            // this.seleIds.push(product.itemId + ',' + standard.itemId + ',' + item.itemId)
          })
        })
      })
      this.tmpProductItemList = []
      this.dialogVisible = true
    },
    toPopVip () {
      this.vip({
        next: function () {},
        payClose: true
      })
    },
    // 确认选择的检验项目
    handleSaveTestPorject () {
      // 210113 add by start 吴家辉
      for (let i = 0; i < this.tmpProductItemList.length; i++) {
        let node = this.tmpProductItemList[i]
        if (node.refines && node.refines.length > 0 && !node.selRefine.id) {
          this.$message.warning('请选择(产品)' + node.itemName + '的细化分类')
          return false
        }
      }
      // 210113 add by end   吴家辉
      // 210128 add by start 吴家辉
      /*
      for (let j = 0; j < this.tmpProductItemList.length - 1; j++) {
        let addPro1 = this.tmpProductItemList[j]
        let addPro2 = this.tmpProductItemList[j + 1]
        // console.log(addPro1)
        // console.log(addPro2)
        if (addPro1.itemId !== addPro2.itemId) {
          this.$message.warning('请选择同种产品')
          return false
        }
      }
      let brk = false
      for (let i = 0; i < this.entrust.productItemList.length; i++) {
        let nowPro = this.entrust.productItemList[i]
        if (brk) {
          break
        }
        // console.log(nowPro)
        for (let j = 0; j < this.tmpProductItemList.length; j++) {
          let addPro = this.tmpProductItemList[j]
          // console.log(addPro)
          if (nowPro.itemId !== addPro.itemId) {
            var rel = confirm('您已选择不同种类的产品，是否覆盖之前的选择?')
            if (!rel) {
              return
            } else {
              this.entrust.productItemList = []
              brk = true
              break
            }
          }
        }
      }
      */
      // 210128 add by end   吴家辉
      // 重新组装 合并 truble
      this.tmpProductItemList.forEach(product => {
        // 获取当前选择 和 新选中相同的产品 (细化)
        let selArr = this.entrust.productItemList.filter(v => {
          return v.itemId === product.itemId && v.selRefine.id === product.selRefine.id
        })
        if (selArr.length > 0) {
          // product存在 循环找下一层
          product.standardList.forEach(standard => {
            let tmpStand = selArr[0].standardList.filter(sv => {
              let ret = sv.itemId === standard.itemId
              return ret
            })
            if (tmpStand.length > 0) {
              standard.standardList.forEach(item => {
                this.entrust.productItemList.forEach(p => {
                  if (p.itemId === product.itemId && p.selRefine.id === product.selRefine.id) {
                    p.standardList.forEach(s => {
                      if (s.itemId === standard.itemId) {
                        // s.standardList.push(item)
                        this.addNoSame(s.standardList, item)
                      }
                    })
                  }
                })
              })
            } else {
              this.entrust.productItemList.forEach(p => {
                if (p.itemId === product.itemId) {
                  p.standardList.push(standard)
                }
              })
            }
          })
        } else {
          this.entrust.productItemList.push(product)
        }
      })
      if (this.searchModel === '0') {
        this.testOrgData = []
      } else {
        this.handleSelectTestOrg('auto')
      }
      this.dialogVisible = false
    },
    addNoSame (list, item) {
      let find = false
      list.filter(node => {
        if (node.itemId === item.itemId) {
          find = true
        }
      })
      if (!find) {
        list.push(item)
      }
    },
    handleSave () {
      this.entrust.orgId = this.templateRadio
      if (!this.entrust.productItemList || this.entrust.productItemList.length === 0) {
        this.$message.warning('请选择检验信息')
        return false
      }
      if (this.testOrgData.length === 0 || !this.templateRadio || this.templateRadio === '1') {
        this.$message.warning('请选择机构信息')
        return false
      }
      this.$refs['entrustForm'].validate(valid => {
        if (valid) {
          this.nextLoading = true
          saveTestEntrustFirstPage(this.entrust)
            .then(res => {
              this.nextLoading = false
              var result = res.data
              if (result.rtnCode !== '0') {
                this.$message({
                  type: 'info',
                  message: result.msg
                })
              } else {
                this.entrust.id = result.bizData
                this.$emit('next', this.entrust.id)
              }
            }).catch(ex => {
              this.nextLoading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        }
      })
    },
    // 删除项目
    handleDelItem (proIndex) {
      if (this.entrust.productItemList[proIndex].standardList.length === 0) {
        this.entrust.productItemList.splice(proIndex, 1)
      }
      if (this.searchModel === '0') {
        this.testOrgData = []
      } else {
        this.handleSelectTestOrg('auto')
      }
    },
    // 删除标准
    handleDelStandard (index) {
      this.entrust.productItemList.splice(index, 1)
      if (this.searchModel === '0') {
        this.testOrgData = []
      } else {
        this.handleSelectTestOrg('auto')
      }
      this.selectOptions.cycleOptions = this.commonUtils.getDictPara('sys_cycle')
    },
    resetPrice () {
      // 1、获取已选择的数据
      // this.entrust.cycleCode reportSendCode reportTypeCodeArray
      // 2、循环列表，取每一个对象
      let that = this
      this.testOrgData.forEach(org => {
        let newPirce = 0
        // 报告及发票
        let thatSub = that
        org.sendTypeList.forEach(send => {
          if (thatSub.entrust.reportSendCode === send.code) {
            newPirce += isNaN(send.price) ? 0 : send.price
          }
        })
        // 报告类型
        org.reportTypeList.forEach(report => {
          if (thatSub.entrust.reportTypeCodeArray.indexOf(report.code) > -1) {
            newPirce += isNaN(report.price) ? 0 : report.price
          }
        })
        // 检验周期
        let priceSite = 0
        let priceVipSite = 0
        org.cycleList.forEach(cycle => {
          if (thatSub.entrust.cycleCode === cycle.code) {
            priceSite = (isNaN(cycle.price) ? 0 : cycle.price) * 0.01 // 加成倍率
            priceVipSite = (isNaN(cycle.vipPrice) ? 0 : cycle.vipPrice) * 0.01 // 加成倍率
          }
        })
        let pirce = newPirce + (priceSite + 1) * org.price
        let vipPrice = newPirce + (priceVipSite + 1) * org.price
        org.disPrice = pirce.toFixed(2)
        org.vipPrice = vipPrice.toFixed(2)
      })
      this.testOrgData = _.cloneDeep(this.testOrgData)
    },
    // 搜索机构
    handleSelectTestOrg (auto) {
      this.loading = true
      // 请求获取数据
      let param = {}
      param.cycleCode = this.entrust.cycleCode
      param.qualificationsArray = this.entrust.qualificationsCodeArray
      param.reportSendCode = this.entrust.reportSendCode
      param.reportTypeArray = this.entrust.reportTypeCodeArray
      let standardItemList = []
      this.entrust.productItemList.forEach(product => {
        product.standardList.forEach(standard => {
          standard.standardList.forEach(item => {
            var node = {
              productId: product.itemId,
              standardId: standard.itemId,
              itemId: item.itemId
            }
            if (product.selRefine && product.selRefine.id) {
              node.refineId = product.selRefine.id
              node.refineName = product.selRefine.name
              node.refineFullName = product.selRefine.fullName
            }
            standardItemList.push(node)
          })
        })
      })
      param.standardItemList = standardItemList
      this.orgLoading = true
      getInspectionOrgList(param)
        .then(res => {
          this.orgLoading = false
          var result = res.data
          if (result.rtnCode !== '0') {
            if (auto) {
              this.testOrgData = []
            } else {
              this.$message({
                type: 'info',
                message: result.msg
              })
            }
          } else {
            this.testOrgData = result.bizData
            if (this.testOrgData.length > 0) {
              if (this.templateRadio !== '1') {
                let tmp = this.templateRadio
                this.templateRadio = '1'
                this.testOrgData.forEach(v => {
                  if (v.id === tmp) {
                    this.templateRadio = tmp
                    this.selOrg = v
                    this.orderRemark = v.orderRemark
                    this.selectOptions.cycleOptions = this.testOrgData[0].cycleList
                  }
                })
              } else {
                this.templateRadio = this.testOrgData[0].id
                this.selectOptions.cycleOptions = this.testOrgData[0].cycleList
              }
              this.resetPrice()
            }
          }
        }).catch(ex => {
          this.orgLoading = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
    },
    viewPiceDetail (row) {
      this.productItem = row
      this.titlePrice = '费用明细 —— ' + row.name
      this.dialogPrice = true
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .el-table th > .cell{
    height: 30px;
    line-height: 32px;
  }
  .beVip {
    position: relative;
    .beVipImg {
      height: 29px;
      position: absolute;
      top: -8px;
    }
    .beVipImg:hover {
      cursor: pointer;
    }
  }
</style>
